"use client";

import dynamic from "next/dynamic";

/**
 * The lazy edge to OfferPlacement's checkout modes. It is its own client
 * module so a server page that renders only `mode="collect_inputs"` references
 * this tiny boundary, never the checkout module itself, and the placement
 * runtime stays out of its first-load JS.
 */
const loadCheckout = () =>
  import("@/components/OfferPlacement.checkout").then((mod) => mod.CheckoutOfferPlacement);

// The continuation card holds its frame's 320px reserve while the chunk loads,
// so the kundali result never shifts; an action reserves nothing, as before.
export const ContinuationCheckout = dynamic(loadCheckout, {
  loading: () => <div className="min-h-80" />,
});
export const ActionCheckout = dynamic(loadCheckout);
